import { useQuery } from '@tanstack/react-query'

import { getLeadsReport } from './functions'

function useLeadsReport(
  dateRange: { to: string; from: string },
  isMyTeamsReq: boolean
) {
  return useQuery(
    ['leadsReport', { dateRange, isMyTeamsReq }],
    () => getLeadsReport(dateRange, isMyTeamsReq),
    { enabled: false, cacheTime: 0, staleTime: 0 }
  )
}

export { useLeadsReport }
